import { useState, useEffect } from 'react';
import { AdminService } from '../../../../core/services/AdminService';
import { DataBeanProperties } from '../../../../core/services/model/server-response.interface';
import Select from 'react-select';

interface Props {
    idSelector: number;
    onChange: any;
    _MenuType: number;
    _idAplication: number;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectorAplicationMenuV2 = ({ idSelector, onChange, _MenuType, _idAplication, label, returnType = "ID" }: Props) => {

    const service = new AdminService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDApplicationType === idSelector);
            if (found) {

                setSelectedOption({
                    value: found.DataBeanProperties.IDApplicationType,
                    label: `${found.DataBeanProperties.Name} ${found.DataBeanProperties.MenuValueName ? `- ${found.DataBeanProperties.MenuValueName}` : ''}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    useEffect(() => {
        getLista();
    }, [_MenuType, _idAplication])


    const getLista = () => {
        service.getApplicationTypeCatalogByMenuTypeandIdAplication(_MenuType, _idAplication).subscribe((resp: any) => {
            //console.log("Application", resp);
            if (resp.DataBeanProperties.ObjectValue) {
                setLista(resp.DataBeanProperties.ObjectValue);
            }
        });
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDApplicationType,
        label: `${item.DataBeanProperties.Name} ${item.DataBeanProperties.MenuValueName ? `- ${item.DataBeanProperties.MenuValueName}` : ""}`,
        item: item
    }));

    return (
        <>
            <label className='mb-2'>Aplicación / Menú</label>
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una Menu..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </>
    )
}
